import React, { FunctionComponent } from "react";
import styles from "./css/Section4.module.css";
import { useSelector } from "react-redux";
import consultation2 from "../../assets/mariana_pics/consultation2.png";

const Section4 = () => {
  const language = useSelector((state: any) => state.language.value);

  return (
    <div className={styles.mainContainer}>
      {language === "EN" && (
        <>
          <div className={styles.leftElement}>
            <div className={styles.header}>
              <div className={styles.conversationBenefits}>
                <span className={styles.conversationOffers}>
                  What does this{" "}
                </span>
                <span className={styles.conversation11}>
                  1:1 conversation offer?
                </span>
              </div>
              <span className={styles.shareLearnings}>
                Today, I want to share with you what I've learned and help you
                find your inner freedom.
              </span>
            </div>

            <div className={styles.consultation8}>
              <div className={styles.group9}>
                <div className={styles.rectangleA} />
                <div className={styles.formatOnline}>
                  <span className={styles.format}>
                    Format:
                    <br />
                  </span>
                  <span className={styles.online}>Online</span>
                </div>
              </div>

              <div className={styles.divider}></div>

              <div className={styles.groupB}>
                <div className={styles.rectangleC} />
                <span className={styles.duration}>
                  Duration:
                  <br />
                  60 minutes
                </span>
              </div>

              <div className={styles.divider}></div>

              <div className={styles.groupD}>
                <div className={styles.rectangleE} />
                <span className={styles.cost}>
                  Cost:
                  <br />
                  100 €
                </span>
              </div>
            </div>
          </div>

          <div className={styles.meeting}>
            <img src={consultation2} className={styles.image} />
          </div>
          <div className={styles.content}>
            <div className={styles.group}>
              <span className={styles.safeSpace}>
                A safe and empathetic space where you can explore who you truly
                are.
              </span>
              <div className={styles.rectangle} />
            </div>
            <div className={styles.group1}>
              <span className={styles.indrumareAutentica}>
                Authentic guidance to overcome blockages and reconnect with your
                essence.
              </span>
              <div className={styles.rectangle2} />
            </div>
            <div className={styles.group3}>
              <span className={styles.inspiratieInstrumentePractice}>
                Inspiration and practical tools to live your freedom fully.
              </span>
              <div className={styles.rectangle5} />
            </div>
            <div className={styles.group6}>
              <span className={styles.boostConfidence}>
                A boost of confidence that you can have the life you dream of,
                even if it seems impossible right now.
              </span>
            </div>
          </div>
        </>
      )}
      {language === "RO" && (
        <>
          <div className={styles.leftElement}>
            <div className={styles.header}>
              <div className={styles.conversationBenefits}>
                <span className={styles.conversationOffers}>
                  Ce îți oferă această{" "}
                </span>
                <span className={styles.conversation11}>conversație 1:1?</span>
              </div>
              <span className={styles.shareLearnings}>
                Astăzi, vreau să împart cu tine ceea <br />
                ce am învățat și să te ajut să-ți găsești libertatea interioară.
              </span>
            </div>

            <div className={styles.consultation8}>
              <div className={styles.group9}>
                <div className={styles.rectangleA} />
                <div className={styles.formatOnline}>
                  <span className={styles.format}>
                    Format:
                    <br />
                  </span>
                  <span className={styles.online}>Online</span>
                </div>
              </div>

              <div className={styles.divider}></div>

              <div className={styles.groupB}>
                <div className={styles.rectangleC} />
                <span className={styles.duration}>
                  Durată:
                  <br />
                  60 de minute
                </span>
              </div>

              <div className={styles.divider}></div>

              <div className={styles.groupD}>
                <div className={styles.rectangleE} />
                <span className={styles.cost}>
                  Cost:
                  <br />
                  100 €
                </span>
              </div>
            </div>
          </div>

          <div className={styles.meeting}>
            <img src={consultation2} className={styles.image} />
          </div>
          <div className={styles.content}>
            <div className={styles.group}>
              <span className={styles.safeSpace}>
                Un spațiu sigur și plin de empatie unde poți explora cine ești
                cu adevărat.
              </span>
              <div className={styles.rectangle} />
            </div>
            <div className={styles.group1}>
              <span className={styles.indrumareAutentica}>
                Îndrumare autentică pentru a depăși blocajele și a te conecta cu
                esența ta.
              </span>
              <div className={styles.rectangle2} />
            </div>
            <div className={styles.group3}>
              <span className={styles.inspiratieInstrumentePractice}>
                Inspirație și instrumente practice pentru a-ți trăi libertatea
                pe deplin.
              </span>
              <div className={styles.rectangle5} />
            </div>
            <div className={styles.group6}>
              <span className={styles.boostConfidence}>
                Un boost de încredere că poți avea viața la care visezi, chiar
                dacă momentan pare imposibil.
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Section4;
